import React from 'react';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-133" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-6xl" data-id="element-134" data-mp="3ggaqfufcyb4x">
        <p className="font-serif text-3xl tracking-tight" data-id="element-135" data-mp="3ghc0pwojutll">
          DRUM READY<span className="align-super text-[0.5em]" data-id="element-136" data-mp="32p5qer82vgu2">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-137" data-mp="36oo8zgcffftq">
          DRUM READY™ is an independent teaching resource for drum teachers. It is not affiliated with or endorsed by any exam board, publisher or drum school.
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-138" data-mp="36msyjwt2ysh">
          © 2026 DRUM READY™. All rights reserved.
        </p>
      </div>
    </footer>;
}